// assets
import { IconDashboard, IconBook2, IconFileInfo, IconFileCheck, IconHourglass, IconCheckbox, IconListCheck } from '@tabler/icons';

// constant
const icons = {
    IconDashboard,
    IconBook2,
    IconFileInfo,
    IconFileCheck,
    IconHourglass,
    IconCheckbox,
    IconListCheck
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const qpEmployeeDashboard = {
    id: 'qpEmployeeMainMenu',
    type: 'group',
    children: [
        {
            id: 'dashboard-home',
            title: 'Dashboard',
            type: 'item',
            url: 'qp-employee/home',
            breadcrumbs: true,
            icon: icons.IconDashboard
        },
        {
            id: 'day-book',
            title: 'Day-book',
            type: 'item',
            url: 'qp-employee/day-book',
            breadcrumbs: true,
            icon: icons.IconBook2
        },
        {
            id: 'pending-approval',
            title: 'Pending-approval',
            type: 'item',
            url: 'qp-employee/pending-approval',
            breadcrumbs: true,
            icon: icons.IconHourglass
        },
        {
            id: 'mysel-approval',
            title: 'My-approval',
            type: 'item',
            url: 'qp-employee/myself-approval',
            breadcrumbs: true,
            icon: icons.IconCheckbox
        },
        {
            id: 'transaction-list',
            title: 'Ledger Transaction List',
            type: 'item',
            url: 'qp-employee/transaction-list',
            breadcrumbs: true,
            icon: icons.IconListCheck
        }
    ]
};

export default qpEmployeeDashboard;
